"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.sync.model.button': 'Sync Model',
    'chat.sync.model.tooltip': 'Sync to conversation model',
};
